import { RMTableHeadingWithAddRemoveBtns } from 'components/customComponents/Controls/RMTableHeadingWithAddRemoveBtns';
import { Input } from 'components/input';
import React from 'react';

export interface Props {
  inputField: any;
}

export const MergeIngredientInputs = (props: Props) => {
  const { inputField } = props;
  return (
    <>
      <RMTableHeadingWithAddRemoveBtns
        tableHeading={inputField.tableHeading}
        onClickAddBtn={inputField.onClickAddBtn}
        onClickRemoveBtn={inputField.onClickRemoveBtn}
        showAddButton={inputField.showButtons}
        showDeleteButton={inputField.showButtons}
        errorMessage={inputField.error}
      ></RMTableHeadingWithAddRemoveBtns>
      <Input id={`mergeingredientinputs-${inputField.value ?? ''}`} value={inputField.value ?? ''} onFocus={inputField.onFocus}></Input>
    </>
  );
};
